var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "py-4 flex relative",
      attrs: { id: `question_${_vm.index + 1}` },
    },
    [
      _c(
        "span",
        {
          staticClass:
            "w-20 py-5 px-2 text-3xl leading-relaxed absolute transform -translate-y-3 lg:px-6 lg:translate-y-0",
        },
        [_vm._v(_vm._s(_vm.index + 1))]
      ),
      _c(
        "div",
        {
          class: [
            "min-w-0 flex-1 py-3 flex flex-col gap-y-2 lg:pl-20 lg:py-5 lg:pl-14 gap-y-2",
            [_vm.isMobile ? "pl-20" : "pl-10"],
          ],
        },
        [
          [
            _c(
              "div",
              { staticClass: "-ml-20 pl-20 flex items-start gap-x-1" },
              [
                _c(
                  "p",
                  { staticClass: "w-full rounded-lg py-2.5 px-5 bg-gray-100" },
                  [_vm._v(_vm._s(_vm.question__user.questionTitle))]
                ),
                _vm.bankExam.examType === "QUIZ"
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-x-0.5" },
                      [
                        _c("GrmTextField", {
                          staticClass: "w-20",
                          attrs: { type: "number", disabled: "" },
                          model: {
                            value: _vm.question__user.questionScore,
                            callback: function ($$v) {
                              _vm.$set(_vm.question__user, "questionScore", $$v)
                            },
                            expression: "question__user.questionScore",
                          },
                        }),
                        _c("span", { staticClass: "text-xs" }, [
                          _vm._v(_vm._s(_vm.$t("exam.question.point"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ],
          _c(
            "div",
            {
              staticClass: "flex gap-1",
              class: [_vm.hasEmceeRole() ? "flex-wrap" : "flex-col"],
            },
            _vm._l(_vm.question__user.answerList, function (answer, i) {
              return _c(
                "div",
                { key: i, staticClass: "flex flex-col gap-y-1" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-start" },
                    [
                      _vm.bankExam.examType === "QUIZ" && _vm.hasEmceeRole()
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "bg-blue-50 rounded-lg p-4 text-sm break-all",
                            },
                            [_vm._v(_vm._s(answer.answerText))]
                          )
                        : !_vm.hasEmceeRole()
                        ? _c("GrmTextarea", {
                            staticClass: "min-w-0 flex-1",
                            attrs: {
                              color: "blue",
                              placeholder: _vm.$t("exam.question.placeholder"),
                            },
                            on: {
                              focusout: () => {
                                _vm.onFocusoutAnswer(answer)
                              },
                            },
                            model: {
                              value: answer.answerText,
                              callback: function ($$v) {
                                _vm.$set(answer, "answerText", $$v)
                              },
                              expression: "answer.answerText",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
          _vm.hasEmceeRole()
            ? _c(
                "div",
                { staticClass: "flex flex-col gap-y-2" },
                _vm._l(
                  _vm.subjectiveAnswerList,
                  function (subjectiveAnswer, subjectiveUserId) {
                    return _c(
                      "div",
                      {
                        key: subjectiveUserId,
                        staticClass: "flex items-start gap-1",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "w-max rounded px-2 bg-gray-200 text-xs text-gray-800 font-bold leading-6",
                          },
                          [_vm._v(_vm._s(subjectiveAnswer.username))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "min-w-0 flex-1 flex flex-wrap gap-1",
                          },
                          _vm._l(
                            subjectiveAnswer.answerList,
                            function (answer, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "flex flex-col gap-y-1",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-start" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "border border-blue-400 rounded-lg p-4 text-sm break-all",
                                        },
                                        [_vm._v(_vm._s(answer.answerText))]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }